export default __webpack_public_path__ + "static/media/plain-sticker-b.2c227dbd.png";